import EventEmitter from "./EventEmitter";

export default class Sizes extends EventEmitter {
  constructor(
    width = window.innerWidth,
    height = window.innerHeight,
    pixelRatio = Math.min(window.devicePixelRatio, 2),
  ) {
    super();

    // Setup
    this.width = width;
    this.height = height;
    this.pixelRatio = pixelRatio;

    // Resize event
    window.addEventListener("resize", () => {
      this.resize();
    });
  }

  resize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.pixelRatio = Math.min(window.devicePixelRatio, 2);

    this.trigger("resize");
  }
}
